<template>
	<div class="modal">
		<div class="modal-content update-cost-modal">
			<p class="btn" v-on:click="closeModal">x</p>
			<form v-on:submit.prevent="handleSubmit">
				<div class="input-ctn">
					<div class="label">International Shipping Cost</div>
					<input
						type="text"
						class="input"
						placeholder="International Shipping Cost"
						v-model="costs.internationalShippingCost"
					/>
				</div>
				<div class="input-ctn">
					<div class="label">Chinese Shipping Cost</div>
					<input
						type="text"
						class="input"
						placeholder="Chinese Shipping Cost"
						v-model="costs.chineseShippingCost"
					/>
				</div>
				<div class="input-ctn">
					<div class="label">Local Delivery Cost</div>
					<input
						type="text"
						class="input"
						placeholder="Local Delivery Cost"
						v-model="costs.localDeliveryCost"
					/>
				</div>
				<div class="input-ctn">
					<div class="label">Other Cost</div>
					<input
						type="text"
						class="input"
						placeholder="Other Cost"
						v-model="costs.otherCost"
					/>
				</div>
				<div class="submit">
					<p v-if="loading" class="btn disabled-btn">Creating . . .</p>
					<button v-if="!loading" type="submit" class="btn">Make Order</button>
				</div>
			</form>
		</div>
	</div>
</template>

<script>
export default {
	props: [
		"onSubmit",
		"closeModal",
		"internationalShippingCost",
		"otherCost",
		"localDeliveryCost",
		"chineseShippingCost",
	],
	data() {
		return {
      loading: false,
			costs: {
				otherCost: this.otherCost,
				internationalShippingCost: this.internationalShippingCost,
				chineseShippingCost: this.chineseShippingCost,
				localDeliveryCost: this.localDeliveryCost,
			},
		};
	},
	methods: {
		async handleSubmit() {
			this.loading = true;
			const {
				otherCost,
				internationalShippingCost,
				chineseShippingCost,
				localDeliveryCost,
      } = this.costs;
      this.onSubmit({
        otherCost,
        internationalShippingCost,
				chineseShippingCost,
        localDeliveryCost
      })
		},
	},
};
</script>

<style></style>
